import { jsx as e } from "react/jsx-runtime";
import l from "./roche-pipeline-lane-cell.module.scss.js";
const s = ({ items: i, itemRenderer: n }) => /* @__PURE__ */ e("div", { className: l["pipeline-lane-cell"], children: i.length === 0 ? /* @__PURE__ */ e("div", { className: l["pipeline-lane-cell__empty"], "aria-hidden": "true" }) : /* @__PURE__ */ e("ul", { className: l["pipeline-lane-cell__list"], children: i.map((p, a) => (
  // biome-ignore lint/suspicious/noArrayIndexKey: items don't carry a stable id here, the caller's itemRenderer owns identity
  /* @__PURE__ */ e("li", { className: l["pipeline-lane-cell__item"], children: n(p, a) }, a)
)) }) });
export {
  s as RocheUIPipelineLaneCell
};
